import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Backdrop } from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import Heading from "./Heading";
import { useStyles } from "./styles";
import { VehicleTypeInputs, IForm } from "./VehicleTypeInputs";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function VehicleTypes({ value, index, ...other }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [typesRecord, settypesRecord] = React.useState<any[]>([]);
  const pageHeading = "Vehicle Types";
  const getVehicleTypes = async () => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get("get-all-vehicle-type");
      if (results.isSuccess == true) {
        settypesRecord(results.value);
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  useEffect(() => {
    if (typesRecord.length === 0) getVehicleTypes();
  }, []);
  const updateSubmit = async (formData: IForm) => {
    const clone = JSON.parse(JSON.stringify(formData));
    setLoading(true);
    // API Code
    const res = await ax.put<IApi>("/update-vehicle-type", clone);
    try {
      if (res.data.isSuccess === true) {
        setLoading(false);
        const tempArr = typesRecord.map((x) =>
          x.id === formData.id
            ? {
                ...x,
                name: formData.name,
                weight: formData.weight,
                weightUnit: formData.weightUnit,
                fixedCharges: formData.fixedCharges,
                demurrageCharges: formData.demurrageCharges,
                currencyUnit: formData.currencyUnit,
                isActive: formData.isActive,
              }
            : x
        );
        settypesRecord(tempArr);
      } else {
        throw new Error(res.data?.error || res?.statusText);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const handleSubmit = async (formData: IForm) => {
    try {
      const clone = JSON.parse(JSON.stringify(formData));

      setLoading(true);
      const res = await ax.post<IApi>("/create-vehicle-type", clone, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true) {
        setLoading(false);
        getVehicleTypes();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      throw error;
    }
    return;
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Backdrop className={classes.backdrop} open={loader}>
            <CommonLoader />
          </Backdrop>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                {/* Conent Start */}
                <VehicleTypeInputs
                  updateSubmit={updateSubmit}
                  handleSubmit={handleSubmit}
                  tableRecord={typesRecord || []}
                  loading={loading}
                />
                {/* Conent End */}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
